import { Component, inject, signal } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';

import { UserService } from '@shared/services/user.service';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { EventManager } from '@app/shared/utils/event-manager';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { AuthenticationService } from '@shared/services/authentication.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { Heading2Component } from '@app/shared/components/text/h2/h2.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-manage-password',
  templateUrl: './manage-password.component.html',
  styleUrls: ['./manage-password.component.scss'],
  standalone: true,
  imports: [SharedModule, ReactiveFormsModule, Heading2Component, ButtonComponent],
})
export class ManagePasswordComponent {
  hideNew = signal(true);
  hideCurrent = signal(true);
  componentDestroy: () => Observable<unknown>;
  current = new UntypedFormControl('', [Validators.required, Validators.minLength(6)]);
  new = new UntypedFormControl('', [Validators.required, Validators.minLength(6)]);

  private readonly userService = inject(UserService);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly eventManager = inject(EventManager);
  public readonly logger = inject(LoggerService);

  onSubmit(): void {
    (async () => {
      try {
        await this.authenticationService.changePassword({
          currentPassword: this.current.value,
          newPassword: this.new.value,
        });
        this.close();
      } catch (error) {
        if (error instanceof HttpErrorResponse && error.status === 406) {
          this.current.setErrors({ invalidPassword: true });
        } else {
          this.logger.error(JSON.stringify(error));
        }
      }
    })();
  }

  close() {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.ManagePasswordComponent, ModalType.View));
  }
}
